import * as React from 'react'
import * as domain from '@packages/domain'

interface State {
  readonly crashed: boolean
}

export class RootCrashGuard extends React.Component<React.PropsWithChildren, State> {
  state: State = { crashed: false }

  static getDerivedStateFromError(): State {
    return { crashed: true }
  }

  componentDidCatch(error: unknown): void {
    domain.Error.log(domain.Error.toUnknownError(error))()
  }

  render(): React.ReactNode {
    return this.state.crashed ? (
      <div role="alert" className="indiaudio-crash-fallback">
        <p>
          <strong>Die Vorschau konnte nicht geladen werden</strong>
          <br />
          Bitte versuche es erneut oder kontaktiere den Support, falls das Problem bestehen bleibt.
        </p>
      </div>
    ) : (
      this.props.children
    )
  }
}
